import { GET_ORDER_DETAILS } from '../actions/types';
// import isEmpty from '../validation/is-empty';

const initialState = {
  list: []
}

export default function(state = initialState, action ) {
    switch(action.type) {
        case GET_ORDER_DETAILS:
            // console.log(action.payload);
            return {
                ...state,
                list: action.payload
            }
        default:
            return state;
    }
}
